import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const THANK_YOU_STEP = 'ThankYou';

const propTypes = {
  step: PropTypes.string.isRequired,
};

const MonthlyFormThankYou = ({ step }) => {
  if (step !== THANK_YOU_STEP) { return null; }

  return (
    <Fragment>
      <div className="row margin-bottom-10 text-color-dark-slate text-center">
        <div className="col-xs-12 text-size-16 text-weight-bold">
          <FormattedMessage
            id="common.thanks"
            defaultMessage="THANKS!"
          />
        </div>
      </div>
      <div className="row margin-bottom-80 text-color-dark-slate text-center">
        <div className="col-xs-10 col-xs-offset-1 text-size-14 text-weight-book">
          <FormattedMessage
            id="search.monthly-thanks"
            defaultMessage="We'll be in touch within one business day. Monthly parking will soon be yours!"
          />
        </div>
      </div>
    </Fragment>
  );
};

MonthlyFormThankYou.propTypes = propTypes;
export default MonthlyFormThankYou;
